import angular from 'angular';
import template from './form.html';
import FormController from './form.controller.js';
import {NapomenaEditController} from './napomena.controller.js';


const FormComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: FormController,
    controllerAs: 'vm',
    bindings: {
        model: '<',
        onSubmit: '&',
        onCancel: '&'
    }

};

const NapomenaEditComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: NapomenaEditController,
    controllerAs: 'vm',
    bindings: {
        model: '<',
        onSubmit: '&',
        onCancel: '&'
    }
};

export default FormComponent;
export {NapomenaEditComponent};



// WEBPACK FOOTER //
// ./app/components/pacijent/form/form.js